import {ConfigFileModel} from '../model/config-file.model';

export class LoadConfigFile {
	static readonly type = '[App] LoadConfigFile';
	constructor(public appName: string, public preloadedConfigFile?: any) {}
}

export class MapConfig {
	static readonly type = '[App] MapConfig';
}
export class UpdateAppStart {
	static readonly type = '[App] Update App Start';
	constructor(public tagVersion: string, public appName: string) {}
}

export class UpdateAppEnd {
	static readonly type = '[App] Update End';
	constructor( public appName: string) {}
}

export class SetLogAcknowledge {
	static readonly type = '[App] SetLockAcknowledge';
	constructor(public logAcknowledge: boolean, public appName: string) {}
}

export class SetReleaseNotes {
	static readonly type = '[App] SetReleaseNotes';
	constructor(public releaseNotes: any, public appName: string) {}
}

export class SetDependenciesVersion {
	static readonly type = '[App] SetDependenciesVersion';
	constructor(public dependencies: any, public appName: string) {}
}

// For the Meta reducer if required to Clear one of the Apps
export class ClearModuleState {
	static readonly type = '[App] ClearModuleState';
	constructor(public currentModule: any) {}
}

export class SetCurrentUrl {
	static readonly type = '[Auth]  Set User Current URL';
	constructor(public currentUrl: string, public appName: string) {}
}

export class SetCurrentModule {
	static readonly type = '[Auth]  Set User Current Module';
	constructor(public currentModule: string, public appName: string) {}
}

export class SetCookieEnabled {
	static readonly type = '[Auth]  Set Cookies for display images enabled';
	constructor(public enableCookied: boolean, public appName: string) {}
}

export class SetSecretConfigData {
	static readonly type = '[Auth]  Set Utils Data configured for the given app';
	constructor(public appName: string, public api: string, public route: string) {}
}
